import { createFileRoute } from '@tanstack/react-router'
import {
  LogisticsLayout,
  useOpenLogisticsList,
} from '~/components/routes/logistics/logistics-layout'
import { SimulationDetailMap } from '~/components/routes/logistics/simulation-detail-map'
import { LogisticsRouteGuard } from '~/components/routes/logistics/logistics-route-guard'
import { SimulationDetailPanel } from '~/components/routes/logistics/simulation-detail-panel'
import { useSimulationDetailQuery } from '~/components/routes/logistics/use-simulation-detail-query'
import {
  DETAIL_PANEL_WIDTH_PX,
  LIST_PANEL_LEFT_PX,
} from '~/components/routes/logistics/simulator-layout'
import { withRoutePermissions } from '~/utils/rbac'
import { type LogisticsSearch, logisticsSearchSchema } from '../-search-schema'
import { LOGISTICS_SIMULATION_READ } from '~/components/routes/logistics/tabs'

export const Route = createFileRoute('/_authenticated/logistics/simulations/$simulationId')({
  staticData: {
    permission: LOGISTICS_SIMULATION_READ,
  },
  component: SimulationDetailRoute,
  // Mêmes paramètres que la liste : ses filtres suivent l'utilisateur dans le détail et au retour.
  validateSearch: logisticsSearchSchema,
})
withRoutePermissions(Route)

/** Mêmes gardes que la liste (`logistics/index.tsx`) : flag `logistique` et droit v2. */
function SimulationDetailRoute() {
  const { simulationId } = Route.useParams()
  const search = Route.useSearch()
  // La barre du détail mène à la liste : un onglet ou un filtre choisi ici s'y applique.
  const openList = useOpenLogisticsList(search)

  return (
    <LogisticsRouteGuard permission={LOGISTICS_SIMULATION_READ}>
      <SimulationDetail id={Number(simulationId)} search={search} onSearchChange={openList} />
    </LogisticsRouteGuard>
  )
}

interface SimulationDetailProps {
  id: number
  search: LogisticsSearch
  onSearchChange: (patch: Partial<LogisticsSearch>) => void
}

function SimulationDetail({ id, search, onSearchChange }: SimulationDetailProps) {
  const { detail, runFollowUpError } = useSimulationDetailQuery(id)

  return (
    <LogisticsLayout
      search={search}
      onSearchChange={onSearchChange}
      containerClassName="relative overflow-hidden p-0"
    >
      <SimulationDetailMap detail={detail.data} />

      <div
        className="absolute inset-y-4 z-10"
        style={{ left: LIST_PANEL_LEFT_PX, width: DETAIL_PANEL_WIDTH_PX }}
      >
        <SimulationDetailPanel
          simulationId={id}
          detail={detail.data}
          isLoading={detail.isLoading}
          error={detail.error}
          runFollowUpError={runFollowUpError}
        />
      </div>
    </LogisticsLayout>
  )
}
